import React, { useState } from "react";


import styled from "styled-components";

import { renderColumn } from "utils";
import TableEditCellsNew from "components/Table/TableEditCells/TableEditCellsNew";
import ExclusiveAnyCheckPicker from "components/Form/ExclusiveAnyCheckbox";

import { Badge, Input, Schema, SelectPicker } from "rsuite";

const { NumberType, StringType } = Schema.Types;

const formModel = Schema.Model({
    wz_key: NumberType(),
    de_key: NumberType(),
    sde_key: NumberType(),
    prefix: StringType(),
    account_id: StringType()
});

const actionSelectData = [
    { option: false, label: "Allowed" },
    { option: true, label: "Blocked" },
];

const nullServicePlan = {
    "sp_key": null,
    "sp_name": null,
    "name": "Any"
};


const BlockedDestinationsTable = ({
    data = [],
    service = true,
    loading = false,
    reportLoading = false,

    filter = {},
    accountList = [],
    worldzoneList = [],
    servicePlanList = [],
    destinationList = [],
    subdestinationList = [],

    ...props
}) => {

    // const [editedFieldKeyList, setEditedFieldKeyList] = useState([]);
    // const [deleteKeyList, onDeleteKeys] = useState([]);
    // const [localLoading, setLocalLoading] = useState(isLoading);

    // const [checkedKeys, onChangeCheckedKeys] = useState([]);
    // const [changedData, onChangedData] = useState(false);

    const servicePlansSorted = [...servicePlanList.slice(), nullServicePlan].sort().reverse();
    const filteredServicePlanList = servicePlansSorted ? servicePlansSorted.filter((item) => {
        return !item.gan;
    }) : [];

    const columns = React.useMemo(() => [
        // Zone
        {
            id: "zone",
            name: "Zone",
            dataKey: "wz_key",
            dataType: "nullable",
            align: "center",
            flexGrow: 1,
            menuStyle: { width: 280 },
            model: formModel,
            searchable: true,
            accepter: SelectPicker,
            placeholder: "Zone",
            data: worldzoneList || [],
            labelKey: "name",
            valueKey: "wz_key",
            value: ({ sp_duplicates = [], sde_wz_name = "" }) => {
                const duplicates = sp_duplicates.filter(sp => sp.sp_key);

                return <>
                    {duplicates.length > 1 && <Badge className="duplicates_badge" content={duplicates.length} />}
                    <span className="tableFilters__previewText">{sde_wz_name}</span>
                </>
            }
        },

        // Destination
        {
            id: "destination",
            name: "Destination",
            dataKey: "de_key",
            dataType: "nullable",
            align: "center",
            flexGrow: 1,
            menuStyle: { width: 280 },
            model: formModel,
            searchable: true,
            accepter: SelectPicker,
            placeholder: "Destination",
            data: destinationList || [],
            labelKey: "name",
            valueKey: "de_key",
            value: ({ sde_de_name = "" }) => {
                return <span className="tableFilters__previewText">{sde_de_name}</span>
            }
        },

        // Subdestination
        {
            id: "subdestination",
            name: "Subdestination",
            dataKey: "sde_key",
            dataType: "nullable",
            valueKey: "sde_key",
            labelKey: "name",
            align: "center",
            flexGrow: 2,
            menuStyle: { width: 320 },
            model: formModel,
            searchable: true,
            accepter: SelectPicker,
            labelKey: "name",
            valueKey: "sde_key",
            placeholder: "Subdestination",
            data: subdestinationList || [],

            value: ({ sde_name = "" }) => {
                return <span className="tableFilters__previewText">{sde_name}</span>
            }
        },

        // Prefix
        // {
        //     id: "prefix",
        //     name: "Prefix",
        //     dataKey: "prefix",
        //     dataType: "string",
        //     align: "center",
        //     width: 220,
        //     model: formModel,
        //     searchable: false,
        //     accepter: Input,
        //     placeholder: "Prefix"
        // },

        // Price
        {
            id: "price",
            name: "Price",
            dataKey: "sp_key_list",
            dataType: "array",
            align: "center",
            flexGrow: 2,
            // customField: true,
            accepter: ExclusiveAnyCheckPicker,
            placeholder: "Price",
            data: filteredServicePlanList,
            valueKey: "sp_key",
            labelKey: "name",

            cleanable: false,
            extraCreateProps: {
                cleanable: true
            },

            value: ({ sp_name = "", sp_duplicates = [] }) => {
                const servicePlanName = sp_name || "Any";

                const servicePlanText = sp_duplicates.length ?
                    sp_duplicates.map(sp => {
                        if (!sp.sp_name) {
                            return "Any";
                        }
                        return sp.sp_name;
                    }).join(", ") : servicePlanName;

                return servicePlanText;
            },
            defaultValue: ({ sp_duplicates }) => {
                return sp_duplicates.map(sp => sp.sp_key);
            }
        },

        // Dialer account
        {
            id: "dialer",
            name: "Dialer account",
            dataKey: "account_id",
            dataType: "nullable",
            align: "center",
            flexGrow: 2,
            menuStyle: { width: 360 },
            data: accountList,
            accepter: SelectPicker,
            valueKey: "id",
            labelKey: "name",
            placeholder: "Dialer account",
            virtualized: true,

            loading: reportLoading,

            extraCreateProps: {
                loading: reportLoading
            },

            value: ({ acc_name }) => acc_name || "Any",
            defaultValue: ({ acc_id }) => acc_id || null
        },

        // Block/Allow
        {
            id: "block_allow",
            name: "Block/Allow",
            dataKey: "action",
            align: "center",
            width: 200,
            accepter: SelectPicker,
            data: actionSelectData,
            valueKey: "option",
            labelKey: "label",
            placeholder: "Access",
            model: formModel,

            cleanable: false,
            searchable: false,
            extraCreateProps: {
                searchable: false,
                cleanable: false
            },

            value: ({ action }) => {
                const actionData = actionSelectData.find(({ option }) => option === action);
                return actionData?.label || "";
            },
            defaultValue: ({ action }) => action
        }
    ], [
        service,
        reportLoading,
        worldzoneList,
        destinationList,
        subdestinationList,
        filteredServicePlanList
    ]);

    const renderedColumns = columns.map(renderColumn);

    return (
        <>
            <StyledTable
                rowKey="ab_key"
                rowIdKey="ab_key"
                columns={columns}
                data={data}
                {...props}
                createFormDefaultValue={{
                    action: true
                }}
                addButtonWidth={124}
            >
                {renderedColumns}
            </StyledTable>
        </>
    );
};

export default BlockedDestinationsTable;

const StyledTable = styled(TableEditCellsNew)`
  && {
        .rs-table-row.red .rs-table-cell {
            background: #f7dddd;
        }
        
        .rs-table-row.green .rs-table-cell {
            background: #e2f6de;
        }

         .rs-table-body-row-wrapper .rs-table-cell-content .tableFilters_buttons > .rs-btn {
            width: 30px;
            height: 30px;
            padding: 4px 8px;
        }
        
        .rs-table-body-row-wrapper .rs-table-cell-content .tableFilters_buttons > .rs-btn {
            margin-right: 5px;
        }
        .rs-table-body-row-wrapper .rs-table-cell-content .tableFilters_buttons .rs-btn-lightblue {
            color: var(--color-light);
            background: var(--color-info);
        }

        .rs-form-control-wrapper .rs-error-message.rs-error-message-show {
            top: -6px;
            right: 0px;
            height: 18px;
            border-radius: 10px;
            padding-top: 0;
            border: 0px;

            .rs-error-message-arrow {
                display: none;
            }

            .rs-error-message-inner {
                font-size: 11px;
            }
        }

        .tableFilters__previewText {
            display: inline-block;
            margin-top: 0px;
            line-height: 36px;
            width: 100%;
        }

        .rs-badge.duplicates_badge {
            margin-top: 10px;
            float: left;
        }
    }
`;